// extracted by mini-css-extract-plugin
export var cardTitle = "product-highlight-module--cardTitle--3dc2b";
export var content = "product-highlight-module--content--04b2d";
export var genericContainer = "product-highlight-module--genericContainer--8ae7d";
export var highlightSection = "product-highlight-module--highlightSection--92aed";
export var highlightTitle = "product-highlight-module--highlightTitle--5c7f8";
export var item = "product-highlight-module--item--d6701";
export var priceButton = "product-highlight-module--priceButton--fd122";
export var productCardContainer = "product-highlight-module--productCardContainer--f2e11";
export var productDetails = "product-highlight-module--productDetails--6db52";
export var productImg = "product-highlight-module--productImg--4c5ad";